var exports = {
  "i": "x234b8571--ee0765--wrapper",
  "v": "x234b8571--ee0765--inner",
};

module.exports = exports;
